import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { applyStoredTheme } from "./lib/theme";
import { installAuthFetch } from "./lib/auth";
import "./index.css";

applyStoredTheme();
// Before anything fetches: API calls refresh the session and retry once on a 401.
installAuthFetch();

const rootElement = document.getElementById("root");

if (!rootElement) {
	throw new Error("Root element not found");
}

createRoot(rootElement).render(
	<StrictMode>
		<App />
	</StrictMode>
);
